import Modal from "../common/ui/modal";

const DeleteImage = ({image, removeImage}) => {

    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Image"
                content={[{
                    text: `Are you sure you wish to delete the below image?`,
                    classes: ""
                }, {
                    text: `${image?.fileName}`,
                    classes: "text-blue font-bold"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={false}
                handleConfirm={() => {
                    removeImage(image)
                }}
            />
        </>
    )
}

export default DeleteImage
